import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/pdfIcon.png'
import _imports_1 from '@/assets/img/arrow.download.svg'
import _imports_2 from '@/assets/img/csvIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-cd195d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary__wrapper" }
const _hoisted_2 = { class: "summary" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "leftSide" }
const _hoisted_5 = { class: "col-lg-6 col-md-12 second__col p-0" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "text__container" }
const _hoisted_8 = { class: "output" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, [
  /*#__PURE__*/_createTextVNode("kg CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode("e")
], -1))
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "text__container" }
const _hoisted_13 = { class: "output" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "€", -1))
const _hoisted_15 = { class: "col-lg-6 col-md-12 second__col p-0" }
const _hoisted_16 = {
  key: 0,
  class: "table table-bordered whiteSummaryTable"
}
const _hoisted_17 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { colspan: "4" }
const _hoisted_20 = { class: "table table-bordered whiteSummaryTable" }
const _hoisted_21 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_22 = { class: "total" }
const _hoisted_23 = { class: "table table-bordered whiteSummaryTable" }
const _hoisted_24 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_25 = { class: "total" }
const _hoisted_26 = { class: "rightSide" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "me-2"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downloadIconContainer" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "me-2"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downloadIconContainer" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_33 = {
  key: 0,
  class: "d-flex justify-content-center mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_chart = _resolveComponent("chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.summarySections, (summarySect, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["row first__row", {'mt-3' : i != 0}]),
              key: i
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(summarySect.footprintLabel), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$filters.approximation(summarySect.footprintKgCOe)), 1)
                    ]),
                    _hoisted_9
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Estimated Offsetting Cost In EUR *",
                      text: "Estimated Offsetting Cost In EUR *"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$filters.currency(summarySect.estimatedUSDFootprint)), 1)
                    ]),
                    _hoisted_14
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_chart, {
                  summaryChartVM: summarySect.chart
                }, null, 8, ["summaryChartVM"])
              ])
            ], 2))
          }), 128)),
          (_ctx.$store.state.loggedUser.hasScoringLicense)
            ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_17, [
                      _createVNode(_component_localized_text, {
                        class: "text-center fs_18",
                        localizedKey: "Providers Scoring",
                        text: "Providers Scoring"
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Provider",
                        text: "Provider"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: _ctx.companyManagementScoringCat,
                        text: _ctx.companyManagementScoringCat
                      }, null, 8, ["localizedKey", "text"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: _ctx.productScoringCat,
                        text: _ctx.productScoringCat
                      }, null, 8, ["localizedKey", "text"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: _ctx.socialResponsabilityScoringCat,
                        text: _ctx.socialResponsabilityScoringCat
                      }, null, 8, ["localizedKey", "text"])
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.providersInvolvedWithScoring, (provider, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(provider.providerName), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "scoringLabel",
                          style: _normalizeStyle('background-color:' + provider.scoringPerMacroCat[_ctx.companyManagementScoringCat].key)
                        }, _toDisplayString(provider.scoringPerMacroCat[_ctx.companyManagementScoringCat].value), 5)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "scoringLabel",
                          style: _normalizeStyle('background-color:' + provider.scoringPerMacroCat[_ctx.productScoringCat].key)
                        }, _toDisplayString(provider.scoringPerMacroCat[_ctx.productScoringCat].value), 5)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "scoringLabel",
                          style: _normalizeStyle('background-color:' + provider.scoringPerMacroCat[_ctx.socialResponsabilityScoringCat].key)
                        }, _toDisplayString(provider.scoringPerMacroCat[_ctx.socialResponsabilityScoringCat].value), 5)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.model.providersInvolvedWithScoring.length == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                        _createElementVNode("td", _hoisted_19, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "None provider selected",
                            text: "None provider selected"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_20, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_21, [
                  _createVNode(_component_localized_text, {
                    class: "text-center fs_18",
                    localizedKey: "Water Footprint Summary",
                    text: "Water Footprint Summary"
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Production Phase",
                    text: "Production Phase"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Green Water (liters)",
                    text: "Green Water (liters)"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Blue Water (liters)",
                    text: "Blue Water (liters)"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Grey Water (liters)",
                    text: "Grey Water (liters)"
                  })
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.waterFootprintTotals, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.phase
                }, [
                  _createElementVNode("td", null, _toDisplayString(row.phase), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency((row.greenWater / 1000), 2)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency((row.blueWater / 1000), 2)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency((row.greyWater / 1000), 2)), 1)
                ]))
              }), 128)),
              _createElementVNode("tr", _hoisted_22, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Total (Liters)",
                    text: "Total (Liters)"
                  })
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getTotal("greenWater", _ctx.model.waterFootprintTotals) / 1000, 2)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getTotal("blueWater", _ctx.model.waterFootprintTotals) / 1000, 2)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getTotal("greyWater", _ctx.model.waterFootprintTotals) / 1000, 2)), 1)
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_24, [
                  _createVNode(_component_localized_text, {
                    class: "text-center fs_18",
                    localizedKey: "Land Impact Summary",
                    text: "Land Impact Summary"
                  })
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", _hoisted_25, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Total Land Use (m2)",
                    text: "Total Land Use (m2)"
                  })
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(_ctx.model.landImpact, 2)), 1)
              ])
            ])
          ]),
          _createVNode(_component_localized_text, {
            class: "info",
            localizedKey: "* Current Average Market Value Of High Quality Carbon Credit",
            text: "* Current Average Market Value Of High Quality Carbon Credit"
          })
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              type: "h4",
              class: "white text-center mb-5",
              localizedKey: "Download",
              text: "Download"
            }),
            _createElementVNode("div", {
              class: "downloadButton pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('downloadPDF')))
            }, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_localized_text, {
                  localizedKey: "Visual Report",
                  text: "Visual Report"
                })
              ]),
              _hoisted_29
            ]),
            _createElementVNode("div", {
              class: "downloadButton pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('exportCsv')))
            }, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_localized_text, {
                  localizedKey: "Data Report",
                  text: "Data Report"
                })
              ]),
              _hoisted_32
            ])
          ]),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "btn btn-secondary me-3",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.back()))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Previous",
                    text: "Previous"
                  })
                ]),
                _createElementVNode("button", {
                  class: "btn btn-tertiary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.replace('/dashboard')))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Finish (back home)",
                    text: "Finish (back home)"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}